import React, { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import Markdown from 'markdown-to-jsx';
import { UserContext } from '~contexts/user';
import { wishRoute } from '~helpers/wishRoute';
import LocationContext from '~containers/workers/locationContext';
import { LocationSearch } from '~components/forms/location';
import { seoVars } from './seo-content/sections';
import ContactPricing from './contact-pricing';

const IntakePanel = ({ city, locationId, aiContent = null, showSearch = false }) => {
  const intl = useIntl();
  const history = useHistory();
  const locationContext = useContext(LocationContext);
  const { user } = useContext(UserContext);
  const vars = seoVars(intl, city);
  const intro = intl.messages['containers.city.seo.location.sub-title'];
  const detail = intl.messages['containers.city.seo.accordian-section.content'];
  if (!city || !intro) return null;
  const isWorker = user?.accountType === 'worker';
  const label = intl.formatMessage({ id: isWorker ? 'containers.homepage.hero.buttons.overview.worker' : 'containers.city.seo.cta.buttons.cleaner' }, vars);
  return (
    <div className="c-city-intake">
      <div className="c-city-intake__intro"><p>{intl.formatMessage({ id: 'containers.city.seo.location.sub-title' }, vars)}</p></div>
      <div id="city-intake-description" className="c-city-intake__copy">
        {detail && <Markdown options={{ forceBlock: true }}>{intl.formatMessage({ id: 'containers.city.seo.accordian-section.content' }, vars)}</Markdown>}
        {aiContent?.intro && <p>{aiContent.intro}</p>}
        {aiContent?.sections?.map(section => <section key={section.key}><h2 className="l-headline--secondary">{section.heading}</h2><p>{section.body}</p></section>)}
      </div>
      <ContactPricing locationId={locationId} city={city} />
      <div className="c-city-intake__controls">
        {showSearch && <div className="c-city-intake__search">
          <LocationSearch
            isDataLoading={locationContext?.isLoadingLocation}
            location={{}}
            placeholder={intl.formatMessage({ id: 'containers.workers.subheader.address', defaultMessage: 'Postcode or address' })}
            name="address"
            className="c-autocomplete--focus-disabled"
            onSubmit={(loc) => {
              if (loc?.place_id) history.push({ pathname: '/workers', search: `?locationId=${encodeURIComponent(loc.place_id)}`, state: { location: { locationId: loc.place_id, address: loc.address } } });
            }}
          />
        </div>}
        <div className="c-city-intake__actions">
          <Link className="c-btn c-city-intake__primary" to={wishRoute({ user, locationId })} rel="nofollow">{label}</Link>
        </div>
      </div>
    </div>
  );
};
export default IntakePanel;
